import React from 'react'
import { connect } from 'react-redux'

export default connect(
  state => ({ embedType: state.signupForm.addOrEdit.values.embedType.value }),
  null
)(({ embedType }) =>
  embedType === 'popover' ? (
    // eslint-disable-next-line
    <a className="closeModal" />
  ) : null
)

